import APIController from "./APIController"
const SyncController = () =>{
    //Requesthelper
    const {basicRequest, jsonRequest, getWorkspaceId} = APIController()

    const fetchSyncData = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/all`);
        return data;
    };

    const uploadDTO = async (orderDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_orders`, "POST", orderDTO);
        return data;
    };

    const ping = async () => {
        const data = await basicRequest(`/health`);
        return data;
    }

    return {
        fetchSyncData,
        ping,
        uploadDTO
    }
}

export default SyncController